import React, { useState, useEffect } from 'react'
import {
    Row,
    Col,
    Button,
    Form,
    Input,
    Select,
    notification,
    Spin
} from "antd";
import { SearchOutlined } from "@ant-design/icons";
import StudentDueList from './StudentDueList';
import memberService from '../../api/member.service';
import { SUCCESS_STATUS } from '../../utility/Constants';


const { Option } = Select;

const StudentDueComp = () => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [memberList, setMemberList] = useState(false);
    const [dueList, setDueList] = useState([]);

    useEffect(() => {
        memberService.allMember().then((res) => {
            if (res.data.response_status === SUCCESS_STATUS) {
                setMemberList(res.data.response_data);
                console.log("memberList", res.data.response_data);
            }
        });
    }, []);

    const onFinish = (values) => {
        console.log("Original Form Values:", values);
        setLoading(true);
        setDueList([]);
        const formattedValues = {
            formdata: {
                member_id: values.member_id,
            },
        };
        console.log("Formatted Form Data:", formattedValues);

        // Assuming the API now expects a POST request
        memberService.allMemberDueList(formattedValues)
            .then((res) => {
                setLoading(false);
                console.log("dueList", res.data.response_data );
                if (res.data.response_data.response_status === SUCCESS_STATUS) {
                    if (res.data.response_data.response_data && res.data.response_data.response_data.length > 0) {
                       
                        setDueList(res.data.response_data.response_data);
                    } else {
                        notification.info({
                            message: 'No Data Found',
                            description: 'No data found for the selected criteria.',
                        });
                    }
                } else {
                    notification.error({
                        message: 'Error',
                        description: res.data.response_data.response_msg,
                    });
                }
                form.resetFields();
            })
            .catch(() => {
                setLoading(false);
                notification.error({
                    message: 'Error',
                    description: 'Failed to fetch data.',
                });
            });
    };

    const onSelectMember = () => {
        console.log("Select Member");
    }

    return (
        <>
            <div className="form-input-style">
                <Row className="login-first-step-row" style={{ background: "#f4f4f4" }}>
                    <Col className="form-format-type1 enrollment-form jcp-enrollment" xs={24} xl={24}>
                        <Form
                            form={form}
                            layout="vertical"
                            autoComplete="off"
                            // initialValues={defaultFormValues}
                            onFinish={onFinish}
                        >
                            <Row gutter={20}>
                                <Col xs={24} xl={24}>
                                    <Row gutter={20}>
                                        <Col xs={4} xl={8} style={{ margin: "0.5rem" }}>
                                            <Form.Item
                                                name="member_id"
                                                label="Members"
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: "Select Member",
                                                    },
                                                ]}
                                            >
                                                <Select className="text-left"
                                                    showSearch
                                                    placeholder="Search to Select"
                                                    optionFilterProp="children"
                                                    filterOption={(input, option) =>
                                                        //option.children.includes(input)
                                                        option.children.toLowerCase().includes(input.toLowerCase())
                                                    }
                                                    filterSort={(optionA, optionB) =>
                                                        optionA.children
                                                            .toLowerCase()
                                                            .localeCompare(optionB.children.toLowerCase())
                                                    }
                                                    onSelect={(value, event) =>
                                                        onSelectMember(value, event)
                                                    }
                                                >
                                                    <Option value="">Select</Option>
                                                    {memberList.length > 0
                                                        ? memberList.map((member_list) => (
                                                            <Option
                                                                key={member_list.member_id}
                                                                value={member_list.member_id}
                                                            >
                                                                {`${member_list.member_fname} ${member_list.member_lname
                                                                    } | ${member_list.primary_mobile} | ${member_list.father_name != null
                                                                        ? member_list.father_name
                                                                        : ""
                                                                    }`}
                                                            </Option>
                                                        ))
                                                        : ""}
                                                </Select>
                                            </Form.Item>
                                        </Col>

                                        <Col xs={2} xl={2} style={{ margin: "0.5rem" }}>
                                            <Form.Item label=" ">
                                                <Button
                                                    htmlType="submit"
                                                    shape="round"
                                                    loading={loading}
                                                    className="custom-button-green"
                                                >
                                                    <SearchOutlined />
                                                </Button>
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Form>
                    </Col>
                </Row>
            </div>

            <div className='tableView'>
                <div className="form-content">
                    <StudentDueList dueList= {dueList} />
                </div>
            </div>

        </>
    )
}

export default StudentDueComp